module.exports = __webpack_public_path__ + "scource/logo-default-5f688931.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/navigator/img/logo-default.png
// module id = 416
// module chunks = 1